module.exports = __webpack_public_path__ + "assets/burger-menu-a951ca.svg";